// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3GyNi","signatureButtonsRight":"ModalSign_signatureButtonsRight__1v2zv"};